export const footer = {
    newsletter: {
        label: 'Newsletteranmeldung',
        inputLabels: {
            email: 'E-Mail',
            next: 'Weiter',
            salutation: 'Anrede',
            firstname: 'Vorname',
            lastname: 'Nachname',
            company: 'Firma',
            address: 'Straße und Hausnummer',
            postalCode: 'Postleitzahl',
            city: 'Ort',
            privacyStatement: 'Datenschutzerklärung',
            privacyStatementCheckbox:
                'Ich erkläre mich damit einverstanden, dass Murtfeldt Additive Solutions meine Daten zur Bearbeitung meines Anliegens verwendet. Weitere Informationen und Widerrufshinweise finden Sie in unserer ',
            send: 'Absenden',
        },
        requiredFieldsMissing: 'Nicht alle Pflichtfelder ausgefüllt',
    },
    socialMedia: {
        label: 'Folgen Sie uns auch auf',
    },
    legal: {
        label: 'Rechtliches',
    },
    navigation: {
        reportBug: 'Problem melden',
    },
};